import { ReactNode } from "react";

interface Props {
  children: ReactNode;
  className?: string;
  onChange: () => void;
  testId?: string;
}

function PaymentMethodTile(props: Props) {
  const { children, className = "", onChange, testId } = props;

  return (
    <div
      role="button"
      onKeyDown={onChange}
      tabIndex={0}
      onClick={onChange}
      className={`${className} rounded-lg border border-grey-60 shadow-card px-4 py-5 hover:shadow-cardHover cursor-pointer`}
      data-testid={testId}
    >
      {children}
    </div>
  );
}

export default PaymentMethodTile;
